import { render, staticRenderFns } from "./BatchNumberForm.vue?vue&type=template&id=3ea65d64&"
import script from "./BatchNumberForm.vue?vue&type=script&lang=js&"
export * from "./BatchNumberForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports